import theme from '../../theme';
import { styled } from '@mui/material/styles';
import { Autocomplete, Paper, Popover } from "@mui/material";

export const AutocompleteStyle = styled(Autocomplete)({
  '& .MuiOutlinedInput-root.MuiInputBase-sizeSmall': {
    marginTop: '10px',
    padding: '8px 14px',

    '& .MuiAutocomplete-input': {
      height: '24px',
      cursor: 'pointer',
      backgroundColor: 'transparent',
    },
  },

  '& .MuiInputBase-input': {
    fontSize: '0.875rem',
  },

  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none',
    borderBottom: `1px solid ${theme.palette.grey.w600}`,
    borderRadius: '0px'
  },
})

export const PaperStyle = styled(Paper)({
  fontSize: '0.5rem',
  border: `1px solid ${theme.palette.grey.w400}`,
  boxShadow: `0px 2px 6px ${theme.palette.grey.w400}`,
})

export const PopoverStyle = styled(Popover)({
  border: `1px solid ${theme.palette.grey.w400}`,
  boxShadow: `0px 2px 6px ${theme.palette.grey.w400}`,
})
